import './image-mask-panel.less';
import { useCallback, useEffect, useState } from 'react';
import { BackTitle } from '@meitu/saas-ui/es/title';
import {
    IImageLayerProps,
    ILayerBehavior,
    ILayerProps,
    PosterType,
    StretchOptionType,
} from '@meitu/saas-editor-core/es/version-types';
import { useListenActivePickLayerProps } from '@meitu/saas-editor-ui/es/hooks/use-listen-layer-props';
import ImageMaskList from '@meitu/saas-editor-ui/es/panels/image-layer-panel/components/mask-panel/mask-panel';
import { usePanelLayerId } from '@/hooks';
import { useLocaleStore } from '@/i18n';
import { editor } from '@/instance';
import { fetchMaskList } from '@/services/material';
import { useRecordModel } from '@/store/models/record-model';
import { HandleHbLayersFunc } from '@/utils/stat-track';
import { IImgPanelType } from '../type';

interface IImageMaskPanelProps {
    setPanel: (type: IImgPanelType | null) => void;
    firstId?: number;
}

// 每个分页请求多少个素材
const Material_SIZE = 100;

const getMaskList = async (cursor: string) => {
    const res = await fetchMaskList({
        limit: Material_SIZE,
        type: 'pic_shape',
        cursor,
    });

    const list = ((res.data?.response?.materials as any as []) || []).map((material: any) => {
        return {
            id: material.id.toString(),
            url: material.svg_image_new || material.svg_image,
            threshold: '',
            corner_mark_url: '',
            previewUrl: material.thumbnail,
        };
    });

    return {
        list,
        currentCursor: res.data?.response?.cursor,
    };
};

const ImageMaskPanel: React.FC<IImageMaskPanelProps> = ({ setPanel, firstId }) => {
    const { $t } = useLocaleStore();

    const layerId = usePanelLayerId();

    const getPosterType = useRecordModel((actions) => actions.getPosterType);
    const posterType = getPosterType();
    const maskURL = useListenActivePickLayerProps(editor, (layer) => {
        if (!layer) return null;
        const { maskURL } = layer.data as IImageLayerProps;
        return maskURL;
    });

    const trackCallback = (data: any) => {
        let { id, category, type, vip } = data;

        if (isNaN(parseInt(category))) {
            category = '';
        }
        window._stat_track('tpbj_material_show', {
            func: 'mb',
            material_id: id,
            label_id: category,
            type_id: type,
            belong: 0,
            local_ind: 0,
            material_vip: vip,
        });
    };
    const selectMask = useCallback(
        async ({
            url,
            materialId,
            threshold,
            type_id: typeId,
        }: {
            url: string;
            materialId: string;
            threshold: string;
            type_id: string;
        }) => {
            const layer = editor.services.flatLayer.getLayer(layerId || '');

            if (!layer) return null;
            const data = layer.data as IImageLayerProps;
            const { maskURL } = data;
            if (layer?.id && maskURL !== url) {
                data.stretchOption = StretchOptionType.cover;
                editor.imageLayer.setMask(layer?.id, {
                    url,
                    materialId,
                });
            }

            window._stat_track('tpbj_material_click', {
                func: posterType ? 'team' : 'mb',
                type_id: typeId,
                material_id: materialId,
                label_id: '',
                belong: 0,
                material_vip: threshold || '0',
            });

            HandleHbLayersFunc({
                firstId,
                secondId: 40,
                isUse: true,
                layer,
            } as any);
        },
        [layerId, firstId],
    );
    return (
        <div className="c-image-mask-panel">
            <div className="title">
                <BackTitle
                    text={$t((v) => v.panel.imagePanel.imageMask)}
                    handleBackClick={() => {
                        setPanel(null);
                    }}
                />
            </div>
            <div className="content">
                <ImageMaskList
                    handler={selectMask}
                    isShow={true}
                    trackCallback={trackCallback}
                    getList={getMaskList}
                    activeLayerMaskUrl={maskURL || undefined}
                />
            </div>
        </div>
    );
};

export default ImageMaskPanel;
